$(document).ready(function () {
  let pdfUrls = {};

  const fetchData = (cursor = null) => {
    let query = `
      query {
        metaobjects(type: "alpha_coa_pdf_list", first: 250${cursor ? `, after: "${cursor}"` : ""}) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              fields {
                value
                key
              }
            }
          }
        }
      }
    `;

    $.ajax({
      type: "POST",
      url: "/api/2019-10/graphql.json",
      headers: {
        "X-Shopify-Storefront-Access-Token": "b41ff1fd0a0d2001478b8cb8ed56b625",
        "Content-Type": "application/graphql",
      },
      data: query,
      success: function (response) {
        const { edges, pageInfo } = response.data.metaobjects;
        if (edges.length > 0) {
          edges.forEach((edge) => {
            const { fields } = edge.node;
            let lotNumber, pdfUrl;
            fields.forEach((field) => {
              if (field.key === "lot_number") {
                lotNumber = field.value.trim();
              } else if (field.key === "pdf_file") {
                pdfUrl = field.value.trim();
              }
            });

            if (lotNumber && pdfUrl) {
              fetchFileURL(pdfUrl, lotNumber);
            }
          });

          if (pageInfo.hasNextPage) {
            const lastCursor = edges[edges.length - 1].cursor;
            fetchData(lastCursor); // Recursively fetch next page
          }
        } else {
          console.log('No metaobjects of type "alpha_coa_pdf_list" found.');
        }
      },
      error: function (xhr, status, error) {
        console.error("Error fetching data:", error);
      },
    });
  };

  const fetchFileURL = (url, lotNumber) => {
    $.ajax({
      type: "POST",
      url: "/api/2019-10/graphql.json",
      headers: {
        "X-Shopify-Storefront-Access-Token": "b41ff1fd0a0d2001478b8cb8ed56b625",
        "Content-Type": "application/graphql",
      },
      data: `
        query {
          node(id: "${url}") {
            ... on GenericFile {
              url
            }
          }
        }
      `,
      success: function (response) {
        pdfUrls[lotNumber] = response.data.node.url;
        //console.log("PDF fetched for lot:", lotNumber, response.data.node.url);
      },
      error: function (xhr, status, error) {
        console.error("Error fetching file URL:", error);
      },
    });
  };

  fetchData();

  $("#createIframeBtn").click(function (e) {
    e.preventDefault();
    const inputVal = $("#coa-lot-number").val().trim();
    if (inputVal) {
      if (pdfUrls.hasOwnProperty(inputVal)) {
        const iframeSrc = pdfUrls[inputVal];
        const iframe = $("<iframe>", {
          src: iframeSrc,
          width: "100%",
          height: "600px",
        });
        $("#iframeContainer").empty().append(iframe);
        $("html, body").animate(
          {
            scrollTop: $("#iframeContainer").offset().top - 200,
          },
          "slow"
        );
        $("#pdf-error-message").text("");
      } else {
        $("#pdf-error-message").text(
          `Lot number ${inputVal} was not found. Please try another number.`
        );
        console.log("Lot number not found in fetched list:", inputVal);
      }
    }
  });

  $("#coa-lot-number").on("input", function () {
    if ($(this).val().trim() === "") {
      $("#pdf-error-message").text("");
    }
  });
});
